import { render } from "./AffiliateClients.vue?vue&type=template&id=45b5815c&scoped=true"
import script from "./AffiliateClients.vue?vue&type=script&lang=js"
export * from "./AffiliateClients.vue?vue&type=script&lang=js"

import "./AffiliateClients.vue?vue&type=style&index=0&id=45b5815c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b5815c"]])

export default __exports__